<div *ngIf="content?.cards?.length > 0">
  <eds-carousel-slider
    [preTitle]="content.preTitle"
    [titleLabel]="content.title"
    [textContent]="processedText"
    [sliderItems]="cards"
  ></eds-carousel-slider>
</div>
